import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app/App";
import "@/styles/tokens.css";
import "@/styles/base.css";
import "@/styles/library.css";
import "@/styles/reader.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Marginalia could not find its application root.");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
